import React, {useState, useEffect} from 'react'

import PostContents from './PostPress';
import Pagination from './Pagination.js';
import PostModal from './PostModal.js';

import { useTranslation } from "react-i18next";

const Press = () => {
    const { t } = useTranslation();

    const [tabNumber,setTabNumber] = useState('2'); //선택한 탭 번호
    const [tabName,setTabName] = useState('보도자료'); //선택한 탭 이름
    const [tabToggle,setTabToggle] = useState(false); //탭 토글 데이터 없으면 출력 안되게 함
    const [list,setList] = useState(null); //각 게시판 게시글 리스트
    const [popupToggle,setPopupToggle] = useState(false); //공지사항, 보도자료 팝업
    const [post,setPost] = useState(null); //게시글 한개 클릭시 팝업창에 넘겨줄 게시글 데이터 (1개)

    //pagination
    const page = 15;
    const [curPage,setCurPage] = useState(1);
    const idxOfLast = curPage * page;
    const idxOfFirst = idxOfLast - page;
    const [currentList,setCurrentList] = useState(null);

    useEffect(()=>{
        const parm = setTableName(1);
        // 아래 변수를 고쳐 주세요.
        // {} 하나가 게시글 하나, 변수는 똑같이 통일해야합니다. 내용만 변경.
        const res = [
            {no: 1, title: "울산 규제자유특구, 유전체(게놈) 기반 생명공학(바이오) 빅데이터 활성화 실증 착수", writer: "KOGIC", created_at: "2022-07-04", link:"https://eiec.kdi.re.kr/policy/materialView.do?num=227640&topic="},
            {no: 2, title: "1,700년 전 가야인 이렇게 생겼다?...유니스트 등 공동연구팀 분석 결과 국제학술지 게재", writer: "KOGIC", created_at: "2022-06-22", link:"http://www.iusm.co.kr/news/articleView.html?idxno=949914"},
            {no: 3, title: "AI·반도체·바이오… 미래 핵심기술 바탕 ‘스마트 신산업’ 키운다", writer: "KOGIC", created_at: "2022-03-15", link:"https://m.kmib.co.kr/view.asp?arcid=0924235958"},
            {no: 4, title: "울산 게놈산업 기반될 바이오데이터팜 구축", writer: "KOGIC", created_at: "2021-10-11", link:"https://www.fnnews.com/news/202110080958396304"},
            {no: 5, title: "울산 ‘게놈 바이오 허브 도시’ 착착… 100세 무병시대 이끈다", writer: "KOGIC", created_at: "2021-10-27", link: "https://go.seoul.co.kr/news/newsView.php?id=20211028021002"},
            {no: 6, title: "클리노믹스, 코로나19 국가별 치명률 상관관계 게놈분석 연구결과 논문 발표", writer: "KOGIC", created_at: "2021-10-05", link: "https://mdtoday.co.kr/news/view/179587423913043"},
            {no: 7, title: "한국인 만 명 게놈 해독 완료! … 초대형 바이오 빅데이터 기반 마련", writer: "KOGIC", created_at: "2021-04-28", link: "https://www.unipress.co.kr/news/articleView.html?idxno=3526"},
            {no: 8, title: "5년 만에 한국인 1만명 게놈 해독 완료", writer: "KOGIC", created_at: "2021-04-26", link: "https://www.hani.co.kr/arti/science/science_general/992606.html"},
            {no: 9, title: "게놈 연구자 박종화 교수 “인간 수명 200년 시대 온다”", writer: "KOGIC", created_at: "2021-04-13", link: "https://shindonga.donga.com/3/all/13/2567683/1"},
            {no: 10, title: "[특별기획] “게놈 혁명, 인간 삶의 혁명이 온다”", writer: "KOGIC", created_at: "2021-03-09", link: "http://www.goodmorningcc.com/news/articleView.html?idxno=247521"},
            {no: 11, title: "울산시 ‘게놈서비스산업 특구’ 조성 본격화", writer: "KOGIC", created_at: "2021-01-12", link: "https://www.ulsan.go.kr/u/rep/bbs/view.do?mId=001004003001000000&bbsId=BBS_0000000000000027&dataId=90124"},
            {no: 12, title: "내년까지 407억 투입 울산에 게놈특구 조성…“감염병 대응 기대”", writer: "KOGIC", created_at: "2021-01-12", link: "https://n.news.naver.com/mnews/article/001/0012133526?sid=105"},
            {no: 13, title: "‘100세’ 고래상어 장수 비밀 국내 연구진 실마리 풀었다", writer: "KOGIC", created_at: "2020-08-05", link: "http://www.busan.com/view/biz/view.php?code=2020080510283439330"},
            {no: 14, title: "한국인, 동남아시아 자손들의 복잡한 혼혈 진화 ‘다인족 민족’", writer: "KOGIC", created_at: "2020-06-04", link: "http://www.kienews.com/news/newsview.php?ncode=1065572980244376"},
            {no: 15, title: "“한국인 생각보다 다양하다” 1000명 게놈 분석 결과", writer: "KOGIC", created_at: "2020.05.28", link: "https://www.dongascience.com/news.php?idx=36998"},
            {no: 16, title: "‘울산 1만명 게놈 프로젝트’ 올해 완성된다", writer: "KOGIC", created_at: "2020-02-21", link: "https://www.donga.com/news/Society/article/all/20200220/99802318/1"},
            {no: 17, title: "클리노믹스·UNIST, 자살·우울증 유전자 예측 모델 개발", writer: "KOGIC", created_at: "2019-10-28", link: "https://www.hankyung.com/it/article/201910286539Y"},
            {no: 18, title: "게놈으로 본 우리나라 맹금류 … 고품질 표준게놈지도 완성", writer: "KOGIC", created_at: "2019-10-02", link: "https://news.unist.ac.kr/kor/20191002-1/"},
            {no: 19, title: "산업도시 울산 '바이오헬스산업' 도시로 변신...게놈엑스포에 7500여명 몰려", writer: "KOGIC", created_at: "2019-09-02", link: "https://www.wowtv.co.kr/NewsCenter/News/Read?articleId=201909023762h"},
            {no: 20, title: "울산시, 게놈산업 대중화 '게놈엑스포' 성료", writer: "KOGIC", created_at: "2019-09-01", link: "https://www.ulsanpress.net/news/articleView.html?idxno=335457"},
            {no: 21, title: "'게놈 정보와 게놈 산업의 대중화'…울산 게놈 엑스포 개막", writer: "KOGIC", created_at: "2019-08-28", link: "https://www.yna.co.kr/view/AKR20190828106200057"},
            {no: 22, title: "게놈 게 섯거라…울산과기원서 국내 최초 게놈 산업 박람회", writer: "KOGIC", created_at: "2019-08-23", link: "https://www.hani.co.kr/arti/area/yeongnam/906870.html"},
            {no: 23, title: "동남권원자력의학원, UNIST와 동남권 의과학 기술 발전 협약 체결", writer: "KOGIC", created_at: "2019-01-28", link: "https://www.cnbnews.com/news/article.html?no=398613"},
            {no: 24, title: "언론이 주목한 교수들-배준범, 로드니 루오프, 박종화, 김지윤", writer: "KOGIC", created_at: "2018-10-28", link: "http://news.unist.ac.kr/kor/short-news-20181028/"},
            {no: 25, title: "울산에서 게놈 엑스포 열려", writer: "KOGIC", created_at: "2018-09-03", link: "https://www.ytn.co.kr/_ln/0115_201809031608097672"},
            {no: 25, title: "게놈허브도시, 울산에서 ‘게놈엑스포2018’ 열린다", writer: "KOGIC", created_at: "2018-08-29", link: "http://news.unist.ac.kr/kor/20180829-1/"},
            {no: 26, title: "울산 '게놈 엑스포' 참석하면 유전자 정보 알려줍니다", writer: "KOGIC", created_at: "2018-08-21", link: "https://www.yna.co.kr/view/AKR20180820109300057"},
            {no: 27, title: "울산시 게놈산업 대중화 선도…국내 첫 '게놈 엑스포' 개최", writer: "KOGIC", created_at: "2018-08-08", link: "https://www.yna.co.kr/view/AKR20180808101300057"},
            {no: 28, title: "‘게놈 엑스포 2018’ 울산서 개최, 석학·기업체 관계자 등 1만여명 참가", writer: "KOGIC", created_at: "2018-08-08", link: "http://news.kmib.co.kr/article/view.asp?arcid=0923990952&code=11110000&cp=nv"},
            {no: 29, title: "울산 1만명 게놈 프로젝트’에 참여하세요!", writer: "KOGIC", created_at: "2017-10-12", link: "http://news.unist.ac.kr/kor/20171012-01/"},
            {no: 30, title: "박종화 교수가 들려주는 게놈 이야기", writer: "KOGIC", created_at: "2017-02-07", link: "http://news.unist.ac.kr/kor/unist-magazine-2016-winter_curious-story-u/"},
            {no: 31, title: "국민 표준 게놈지도, ‘코레프(KOREF)’ 공개", writer: "KOGIC", created_at: "2016-11-24", link: "http://news.unist.ac.kr/kor/20161124-02/"},
            {no: 32, title: "무병장수 시대 열 ‘게놈 프로젝트’ 울산에서 출범", writer: "KOGIC", created_at: "2015-11-27", link: "http://news.unist.ac.kr/kor/20151127-01/"}
        ]
        setTabToggle(true);
        setList(res);
        setCurrentList(res.slice(idxOfFirst,idxOfLast));}, [tabNumber])

    useEffect(()=>{
        if(list != null && list.length > 0){
            setCurrentList(list.slice(idxOfFirst,idxOfLast));
        }
    },[curPage])


    function setTableName(num){
        var tableName = ''
        if(num === '2'){
            setTabName('보도자료')
            tableName = 'presses';
        }else if(num === '3'){
            setTabName('갤러리')
            tableName = 'gallery';
        }else if(num === '4'){
            setTabName('문의사항')
            tableName = 'inquiries';
        }else{
            setTabName('공지사항')
            tableName = 'notices';
        }
        return tableName;
    }
    //탭버튼 클릭
    function tabClick(num){
        setTabNumber(num);
    }
    //하단 숫자 클릭
    function numClick(page){
        setCurPage(page);
    }
    //공지사항,보도자료 팝업
    function closePopup(){
        setPopupToggle(false);

    }
    function openPopup(postData){
        setPopupToggle(true);
        setPost(postData);
    }

  return (
    <div className="mid-section-wrap-02">
        <div className="cnt-section-wrap-02">
            <div className="mid-section-cnt">
                <div className="sect-08-tit-01 sect-tit" href="#section-1">{t("header_info_press")}</div>
                <div id="tabs" className="tabs">
                    <div className="tab-content">
                        <PostContents tabName={tabName} list={currentList} openPopup={openPopup}/>
                    </div>
                    {(list != null && list.length > 0) && <Pagination total={list.length} numClick={numClick}/>}
                </div>
            </div>
        </div>
    </div>
  )
}

export default Press